<template>
	<v-card class="personal-profile__section">
		<div v-if="title" class="personal-profile__section__title">
			{{ title }}
		</div>

		<div
			:style="{ marginTop: title ? '12px' : '0' }"
			class="personal-profile__section__wrapper"
		>
			<div v-for="field in filteredFields" :key="field.field">
				<div
					:style="styleSectionInfo(field)"
					class="personal-profile__section__wrapper__info"
				>
					<div
						v-if="field.title"
						class="personal-profile__section__wrapper__info__field-title"
					>
						{{ field.title }}
					</div>

					<span
						v-if="isLinkType(field.type)"
						class="personal-profile__section__wrapper__info__value-link"
						@click="handleLink(field)"
					>
						{{ field.value }}
					</span>

					<span
						v-else-if="field.type === 'html'"
						v-html="field.value"
						class="personal-profile__section__wrapper__info__value"
					/>

					<span v-else class="personal-profile__section__wrapper__info__value">
						{{ field.value }}
					</span>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
import { mapActions } from 'vuex'
export default {
	props: {
		title: String,
		fields: Array,
	},

	computed: {
		filteredFields() {
			return this.fields.filter(
				(f) => f.value !== null && f.value !== '' && f.value !== false
			)
		},
	},

	methods: {
		...mapActions('auth', ['showAlert']),

		styleSectionInfo(field) {
			const hasTitle = field.title && field.title.trim()
			const isNoneSection = field.section === 'None'
			return {
				padding: field.type === 'compose' || !hasTitle || isNoneSection ? '0' : '12px',
				backgroundColor:
					field.type === 'compose' || !hasTitle || isNoneSection ? '#ffffff' : '#f3f3f6',
			}
		},

		isLinkType(type) {
			return [
				'url',
				'facebook',
				'linkedin',
				'instagram',
				'twitter',
				'email',
				'phone',
				'user_logo',
			].includes(type)
		},

		handleLink(field) {
			const value = field.value

			if (field.type === 'email') {
				window.location.href = `mailto:${value}`
				return
			}

			if (field.type === 'phone') {
				navigator.clipboard.writeText(value)
				this.showAlert({ message: 'Phone number copied successfully.' })
				return
			}

			window.open(value, '_self')
		},
	},
}
</script>
